import styled from "styled-components"

export const StyledNameAndPortion = styled.div`
  display: flex;
  padding: var(--spacing_m, 12px) 12px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: var(--card_corner, 8px);
  border: 0.5px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32));
  background: var(--Schemes-Surface-Container-Lowest, #fff);
  box-shadow: 0px 1px 6px 0px rgba(28, 31, 33, 0.06);
`

export const FoodName = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 120%;
`

export const FoodBrand = styled.div`
  font-size: 14px;
`
